
import yippi from "../../assets/images/appDev/mob-2.jpg" ;
import minibar from "../../assets/images/appDev/mob-1.jpg" ;
import kivi from "../../assets/images/appDev/mob-3.jpg" ;
import pixise from "../../assets/images/appDev/mob-4.jpg" ;
import logo1 from "../../assets/images/appDev/logo1.png" ;
import logo2 from "../../assets/images/appDev/logo2.png" ;
import logo3 from "../../assets/images/appDev/logo3.png" ;
import logo4 from "../../assets/images/appDev/logo4.png" ;




 const data1 = [
    {
        id:1,
        name:'Yippi',
        category:'app',
        Link:'http://yippiweb.com/',
        img: yippi,
        logo: logo1,
        category2:'e-commerce',
        desc:"Yippi is an chatting app, we made this social app for chatting "
    },
{
    id:2,
    name:'minibar ',
    category:'app',
    Link: 'https://minibardelivery.com/',
    img: minibar,
    logo: logo2,
    category2:'e-commerce',
    desc:"Minibar is an Wine, Liquor, and Beer delivery app"
},
{
    id:3,
    name:'Kivi Vpn ',
    category:'app',
    Link: 'https://apps.apple.com/in/app/kivi-vpn-fast-secure-proxy/id1613664487',
    img: kivi,
    logo: logo3,
    category2:'e-commerce',
    desc:"Kivi VPN is fast and secure VPN proxy that hides your true IP address and secures your privacy."
},
{
    id:4,
    name:'Pixise ',
    category:'app',
    Link: 'https://apps.apple.com/in/app/pixise-photo-editing-app/id1588624461',
    img: pixise,
    logo: logo4,
    category2:'e-commerce',
    desc:"Pixise is a photo editing app which helps you create amazing photos for social media."
},

 ]

 export default data1;
